/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Checkbox, Input, Radio, RadioGroup } from 'components/forms'
import { Collapse } from 'react-bootstrap'
import { CONFIG } from 'shared/constants'
import { PrivateAddressDisclaimer } from 'registry/forms/shipping-fields'

import css from './registry-visibility.scss'

const { searchLevelOptions } = CONFIG.registry

const RegistryVisibilityFieldset = ({
  className,
  isShippingAddressPrivate,
  passwordAccess,
  searchLevel,
  visitorPassword,
}) => (
  <fieldset className={className}>
    <RadioGroup aria-label="Privacy Options">
      <Radio
        {...searchLevel}
        checked={
          searchLevel.value === searchLevelOptions.babylist ||
          searchLevel.value === searchLevelOptions.public
        }
        help="Visitors can search Babylist to find your registry."
        label={
          <b>
            <i className="fa fa-globe" /> Public
          </b>
        }
        value={searchLevelOptions.babylist}
      />
      {(searchLevel.value == searchLevelOptions.babylist ||
        searchLevel.value == searchLevelOptions.public) && (
        <Checkbox
          {...searchLevel}
          onChange={() => {
            if (searchLevel.value === searchLevelOptions.public) {
              searchLevel.onChange(searchLevelOptions.babylist)
            } else {
              searchLevel.onChange(searchLevelOptions.public)
            }
          }}
          checked={searchLevel.value == searchLevelOptions.public}
          label="Visitors can search Google to find your registry."
          groupClassName={classNames(css.publicCheckbox, 'mbl')}
          help="Listing on Google can take up to two weeks."
        />
      )}
      <Radio
        {...searchLevel}
        checked={searchLevel.value === searchLevelOptions.private}
        help="Visitors must have the direct link to your registry."
        label={
          <b>
            <i className="fa fa-lock" /> Private
          </b>
        }
        value={searchLevelOptions.private}
      />
    </RadioGroup>

    <hr className="mbl" />

    <Checkbox
      {...passwordAccess}
      onChange={(e) => {
        if (!e.target.checked) {
          visitorPassword.onChange(null)
        }
        passwordAccess.onChange(e)
      }}
      className="password-required"
      label="Visitors need a password to access your registry"
    />

    <Collapse in={passwordAccess.checked}>
      <div>
        <Input
          {...visitorPassword}
          error={visitorPassword.touched ? visitorPassword.error : null}
          id="visitor_password"
          label="Visitor Password"
          placeholder="Visitor Password"
        />
      </div>
    </Collapse>

    <Checkbox
      {...isShippingAddressPrivate}
      className="address-private"
      label="Do not share my address with my gift givers."
    />
    {isShippingAddressPrivate.value && <PrivateAddressDisclaimer />}
  </fieldset>
)

RegistryVisibilityFieldset.propTypes = {
  searchLevel: PropTypes.object.isRequired,
  passwordAccess: PropTypes.object.isRequired,
  visitorPassword: PropTypes.object.isRequired,
  isShippingAddressPrivate: PropTypes.object.isRequired,
  className: PropTypes.string,
}

RegistryVisibilityFieldset.defaultProps = {
  className: undefined,
}

// eslint-disable-next-line import/no-default-export
export default RegistryVisibilityFieldset
